import toMap from '~/misc/toMap';

export default toMap([
  'SIMILAR_LOADS_FOUND',
  'SIMILAR_LOADS_SORTED',
  'SIMILAR_LOADS_CRITERIA',
  'SIMILAR_HIDE_THE_LOADS',
  'SIMILAR_HIDE_THE_COMPANY',
  'COLLECTION_THE_COMPANY',
  'NO_COLLECTION_COMPANY',
  'SIMILAR_LOADS_CHECKED',
  'SIMILAR_LOADS_CHECKED_ALL',
  'CLEAR_SIMILAR_CHECKED',
  'UPDATE_SIMILAR_CHECKED',
]);



// WEBPACK FOOTER //
// ./src/modules/similarLoads/types.js